import { FaGem, FaMagnifyingGlass, FaPen, FaTrash } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ListingPage from '../../components/DynamicListingPage';
import { Chip, IconButton, Stack, Tooltip } from '@mui/material';
import { deleteProduct, getProducts } from '../../helpers/http_products_requests';
import { getCategories } from '../../helpers/http_categories_requests';
import { formatWeight } from '../../utils/functions';
import { CurrentSwitch } from '../../components/CurrentSwitch';
import { useMutation, useQuery } from '@tanstack/react-query';
import { usePermissions } from "../../providers/PermissionsProvider";
import { useAuth } from "../../providers/AuthProvider";
import { confirmAndExecuteFn } from '../../utils/functions';
import { useState } from "react";

export default function Products() {

    const { verifyPermission } = usePermissions();

    // Estado para filtros
    const [filterValues, setFilterValues] = useState({});

    const handleFilterChange = (field, value) => {
        setFilterValues(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Buscar categorias para o filtro
    const categoriesQuery = useQuery({ queryKey: ['getCategories'], queryFn: getCategories, staleTime: 1000 * 60 });

    const categories = categoriesQuery?.data?.data?.data?.map(item => ({ value: item.id, label: item.name })) || [];

    const { data, isFetching, refetch } = useQuery({ 
        queryKey: ['getProducts', filterValues], 
        queryFn: () => getProducts(filterValues), 
        staleTime: 1000 * 5 
    });

    const { id: user_id } = useAuth();

    const { products = [] } = data?.data ?? {};

    const columns = [
        { field: 'image', headerName: 'Foto', },
        {
            field: 'name',
            headerName: 'Nome',
        },
        {
            field: 'category',
            headerName: 'Categoria',
        },
        {
            field: 'self_reference',
            headerName: 'Referência Interna',
            type: 'Definir',
        },
        {
            field: 'weights',
            headerName: 'Pesos',
        },
        {
            field: 'actions',
            headerName: 'Ações',
            type: 'number',
        },
    ];

    const deleteMutation = useMutation({
        mutationFn: (id) => deleteProduct(id, user_id),
        onSuccess: () => {
            setTimeout(() => {
                refetch();
            }, 1000);
        }
    });

    const handleDelete = (id) => {
        confirmAndExecuteFn('Tem certeza que deseja deletar este produto?', () => {
            deleteMutation.mutate(id);
        });
    };

    const componentName = 'products';

    const filters = [
        { 
            field: 'is_active', 
            type: 'select', 
            label: 'Status',
            options: [
                { value: '1', label: 'Ativo' },
                { value: '0', label: 'Inativo' }
            ]
        },
        { 
            field: 'category', 
            type: 'select', 
            label: 'Categoria',
            options: categories
        },
    ];

    const renderActions = (row) => (
        <Stack spacing={1} direction={'row'} justifyContent={'center'}>
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Status" arrow placement="top">
                    <span><IconButton disabled><CurrentSwitch title="status" status={row.is_active} /></IconButton></span>
                </Tooltip>
            )}
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Ver detalhes" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/produto-detalhes/${row.id}`}>
                        <FaMagnifyingGlass size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 2) && (
                <Tooltip title="Editar" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/produto-editar/${row.id}`}>
                        <FaPen size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 4) && (
                <Tooltip title="Deletar" arrow placement="top">
                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                        <FaTrash size={20} />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );

    const renderWeights = (row) => (
        <Stack spacing={1} direction={'row'} justifyContent={'center'}>
            <Chip label={formatWeight(row.weights.high_gold_weight)} color="secondary" />
            <Chip label={formatWeight(row.weights.silver_weight)} color="grey" />
        </Stack>
    );

    return <ListingPage 
        canAddData={verifyPermission(componentName, 3)} 
        isLoading={isFetching} 
        icon={FaGem} 
        pageTitle={"Produtos Inovart Gold"} 
        addButtonTitle={"produtos"} 
        addPath={'/produto-cadastrar'} 
        columns={columns} 
        data={products} 
        actions={renderActions} 
        weights={renderWeights}
        filters={filters}
        filterValues={filterValues}
        onFilterChange={handleFilterChange}
    />
};